var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherTrackersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12l1.5 1.5L14 10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17l1.5 1.5L14 15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherTrackersIcon);
export default __webpack_public_path__ + "static/media/OtherTrackersIcon.43c6f1f784564508aa7494eff142c44d.svg";
export { ForwardRef as ReactComponent };